export const MODAL_TITLE = 'Edit Instant RENT Offer';
export const BTN_SUBMIT = 'Submit';
export const DATE_FIELD = 'When would you like to move in?';
export const RENT_FIELD = 'Proposed Rent';
export const OCCUPANTS_FIELD = 'Occupants';
export const NOTE_FIELD = 'Add a personal note to the landlord?';
export const OCCUPANTS_TOOLTIP_TEXT = 'This number is based on the number of partners in the profile';
